import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import Loader from 'components/loader/Loader';
import NoDataAvailable from 'components/notFound/NoDataAvailable';
import GuestReactionView from 'components/reactions/GuestReactionView';
import PostTile from 'components/tile/PostTile';
import Tile from 'components/tile/Tile';
import ComponentWrapper from 'components/wrapper/ComponentWrapper';
import HomeWrapper from 'components/wrapper/HomeWrapper';
import { Fragment, useEffect, useState } from 'react';
import { getTrendingPosts, ITrendingPosts, resetTrendingState } from 'store';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import theme from 'theme';
import { scrollToTop } from 'utils/utils';

function Trending() {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState<boolean>(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { trendingPosts, isTrendingLoading } = useAppSelector(s => s.trending);

  const fetchFollowingPosts = async () => {
    await dispatch(getTrendingPosts());
    //   if (response && response.data?.length > 0)
    //     dispatch(fetchAdsByPosition(AdsPages.FOLLOWING, "A", 3));
  };

  useEffect(() => {
    scrollToTop();
    return () => {
      dispatch(resetTrendingState());
      // dispatch(resetAdsState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HomeWrapper maxWidth="midmd">
        <Stack spacing={theme.spacing(3)} width="100%">
          <Stack direction="row" justifyContent="space-between">
            <Stack>
              <Typography component="div" marginBottom={theme.spacing(1)} variant="title1">
                Trending
              </Typography>
            </Stack>
          </Stack>
          <ComponentWrapper
            withInfiniteScroll
            infiniteScrollProps={{
              loadOnMount: true,
              hasMoreData: false,
              isLoading: isTrendingLoading,
              onBottomHit: fetchFollowingPosts,
            }}
            title=""
          >
            <>
              {trendingPosts && trendingPosts.length > 0 ? (
                <>
                  {trendingPosts.map((post: ITrendingPosts, index: number) => (
                    <Fragment key={(post?.postId as string) + index.toString()}>
                      {['paid-member-post', 'business', 'town-crier-post'].includes(post?.type) ? (
                        <PostTile
                          componentType="trending"
                          post={post}
                          withDivider={
                            (index + 1) % 5 === 0 ? false : !(trendingPosts?.length === index + 1)
                          }
                        />
                      ) : (
                        <Tile
                          key={post?.documentId}
                          commentsCount={post?.commentsCount}
                          componentType="trending"
                          description={post?.description}
                          id={post?.postId}
                          image={post?.thumbnail as string}
                          isLiked={post?.isLiked}
                          likesCount={post?.likesCount}
                          name={post?.postProvider}
                          postedAt={post?.postedAt as string}
                          providerId={post?.postProviderId}
                          providerLogo={post?.postProviderLogo}
                          tileType={isMobile ? 'small' : 'large'}
                          title={post?.title}
                          type={post?.type}
                          withDivider={
                            (index + 1) % 5 === 0 ? false : !(trendingPosts?.length === index + 1)
                          }
                        />
                      )}
                      {/* {(index + 1) % 5 === 0 && (
                      <AdvertisementTile
                        page={AdsPages.FOLLOWING}
                        position="A"
                        uniqueKey={index + 1}
                        useCommonData={false}
                      />
                    )} */}
                    </Fragment>
                  ))}
                </>
              ) : (
                !isTrendingLoading && <NoDataAvailable />
              )}
              {isTrendingLoading && <Loader />}
            </>
          </ComponentWrapper>
        </Stack>
      </HomeWrapper>
      {showModal && (
        <GuestReactionView isMobile={isMobile} setShowModal={setShowModal} showModal={showModal} />
      )}
    </>
  );
}

export default Trending;
